import { p as presets } from "../presets.js";
import { m as makeColorsConfig } from "./make-config.js";
const getColorDefaultConfig = () => makeColorsConfig({
  threshold: 150,
  presets: {
    light: presets.light,
    dark: presets.dark
  },
  currentPresetName: "light"
});
export {
  getColorDefaultConfig as g
};
//# sourceMappingURL=default.js.map
